// Central design token constants. Aligned with the game-* Tailwind color scale (SF-66).
// New code: use Tailwind `game-*` classes directly.
// Existing pages: continue importing COLORS (pointing to the same game-* values).

export const COLORS = {
  // Backgrounds
  bg:            '#0f1420',   // game-900: Page background
  bgBar:         '#11141f',   // game-850: TopBar background
  card:          '#171c2c',   // game-800: Card / panel background
  cardAlt:       '#0b0e17',   // game-950: Inset elements (inputs, resource pills)
  sectionHeader: '#1b2032',   // game-750: Section headers inside cards
  tableRowAlt:   '#11141f',   // game-850: Alternating table rows (even rows)

  // Borders
  border:       '#22293f',   // game-700: Card borders
  borderBar:    '#1b2032',   // game-750: TopBar border
  borderInset:  '#1b2032',   // game-750: Resource pill borders
  separator:    '#22293f',   // game-700: Pipe separators

  // Text tiers (T2–T5)
  text: {
    primary:   '#ece6d8',   // game-50:  T2 key metrics (~14.8:1 WCAG AAA, warm/parchment)
    secondary: '#a3a8bd',   // game-200: T3 supporting values (~7.8:1 WCAG AAA)
    tertiary:  '#939ab5',   // game-400: T4 labels + T5 section headers (~6.1:1 AA on card ground — nudged from mockup's #838aa6, SF-125 Phase 3 Decision 6)
    muted:     '#495888',   // game-500: Decorative ONLY (fails WCAG AA for normal text)
  },

  // Semantic
  gold:           '#d4a72c',   // Economy accent / networth
  positive:       '#4fae74',   // Success, positive delta
  negative:       '#ff5555',   // Error, danger
  warning:        '#e0923c',   // Warning, amber
  progressYellow: '#f0bd3c',   // Progress color: approaching target (50–99%)
  progressBuilt:  '#3b82f6',   // Building progress bar: built/owned segment (blue)
  progressInProgress: '#93c5fd', // Building progress bar: in-progress construction segment (light blue)
  link:           '#6a9e8e',   // Links, science pillar sage/teal
  accentStrong:   '#f0bd3c',   // Hover/active state for accent-colored (gold) elements
  accentInk:      '#1c1400',   // Text/icon color for use on top of an accent-colored background
  magic:          '#8b83e0',   // Spell/magic-effect status-dot accent
  magicInk:       '#12102b',   // Text/icon color for use on top of a magic-colored background

  // Semantic feedback (error/success message banners)
  errorBg:       '#2a1414',  // Error banner background
  errorBorder:   '#4a2020',  // Error banner border
  errorText:     '#ff5555',  // Error banner text
  successBg:     '#142a14',  // Success banner background
  successBorder: '#204a20',  // Success banner border
  successText:   '#4fae74',  // Success banner text

  // Interactive
  inputBg:     '#0b0e17',   // game-950
  inputBorder: '#22293f',   // game-700
  inputFocus:  '#353f62',   // game-600: Focus ring color

  // Buttons
  btnPrimary:      '#1e3a3a',   // Primary button background (deep sage)
  btnPrimaryHover: '#2a4a4a',   // Primary button hover (brighter sage)
} as const;

/** Reusable inline style for dark-theme text inputs */
export const INPUT_STYLE = {
  backgroundColor: COLORS.cardAlt,
  borderColor:     COLORS.border,
  color:           COLORS.text.primary,
} as const;
